import { defineMessages, type IntlShape, type MessageDescriptor } from 'react-intl';

import type { PermissionName } from '@heidi/agents/contracts';

const labelMessages: Record<PermissionName, MessageDescriptor> = defineMessages({
  screen_recording: {
    defaultMessage: 'Screen Recording',
    id: '+5Na0FTCk1',
    description: 'Label for the macOS Screen Recording permission',
  },
  input_monitoring: {
    defaultMessage: 'Input Monitoring',
    id: 'cpWmViTCn0',
    description: 'Label for the macOS Input Monitoring permission',
  },
  accessibility: {
    defaultMessage: 'Accessibility',
    id: 'S3NwcOtikD',
    description: 'Label for the macOS Accessibility permission',
  },
});

const descriptionMessages: Record<PermissionName, MessageDescriptor> = defineMessages({
  screen_recording: {
    defaultMessage:
      'Lets Heidi capture your screen while recording or running desktop tasks.',
    id: '3RPmsbdXDB',
    description: 'Explains why Heidi needs the Screen Recording permission',
  },
  input_monitoring: {
    defaultMessage:
      'Lets Heidi observe keyboard and mouse input while you record a workflow.',
    id: 's5DyHJNsjD',
    description: 'Explains why Heidi needs the Input Monitoring permission',
  },
  accessibility: {
    defaultMessage: 'Lets Heidi control apps and windows while running desktop tasks.',
    id: 'nruEacnyij',
    description: 'Explains why Heidi needs the Accessibility permission',
  },
});

export const permissionLabel = (intl: IntlShape, permission: PermissionName): string =>
  intl.formatMessage(labelMessages[permission]);

export const permissionDescription = (
  intl: IntlShape,
  permission: PermissionName
): string => intl.formatMessage(descriptionMessages[permission]);
